import React from 'react';

const MapRedirect = (props) => {
  const googleMapsUrl = "https://maps.app.goo.gl/e9ayCh6SNigvrtp17"; // Replace with your location

  return (
    
      <a
        href={googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center"
        style={{ color: 'white' }}
      >
        <span>{props.text}</span>
      </a>
  );
};

export default MapRedirect;
